import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
	FreudTagModule,
	FreudTypographyModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { AccordionComponent } from './accordion.component';

@NgModule({
	declarations: [AccordionComponent],
	imports: [
		CommonModule,
		TranslateModule.forChild(),
		FreudTypographyModule,
		FreudTagModule,
	],
	exports: [AccordionComponent],
})
export class AccordionModule {}
